import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
} from '@angular/core';
import {
  Dialog,
  MODAL_OPTIONS,
  ModalOptions,
} from '../../../core/providers/modal/modal-types';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'vsf-promotion-terms-conditions-modal',
  templateUrl: './promotion-terms-conditions-modal.component.html',
})
export class PromotionTermsConditionsModalComponent
  implements Dialog, AfterViewInit, OnDestroy
{
  descriptionHtml!: string;
  title = 'Terms & Conditions';

  safeDescription!: SafeHtml;
  resolveWith!: () => void;

  private clickListener!: () => void;

  constructor(
    @Inject(MODAL_OPTIONS) private options: ModalOptions<PromotionTermsConditionsModalComponent>,
    private sanitizer: DomSanitizer
  ) {
    if (options.locals) {
      this.descriptionHtml = options.locals.descriptionHtml ?? '';
      this.title =
        options.locals.title ?? this.title;
    }
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(
      this.descriptionHtml
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.clickListener = this.close.bind(this);
      document.addEventListener('click', this.clickListener);
    }, 300);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.clickListener);
  }

  close(): void {
    this.resolveWith();
  }
}
